// extracted by mini-css-extract-plugin
export default {"head":"applications_head__ZactX"};